import React, { FC } from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './HeaderBanner.module.scss';

interface HeaderBannerProps {
  isMobileView?: boolean;
  titleKey: string;
  subtitleKey: string;
  className: string;
  dataHook?: string;
}

const HeaderBanner: FC<HeaderBannerProps> = ({
  titleKey,
  subtitleKey,
  isMobileView,
  className,
  dataHook,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      className={`${s.bannerWrapper} ${
        isMobileView ? s.mobileView : s[className]
      }`}
    >
      <Box
        direction="vertical"
        className={s.textWrapper}
        gap={isMobileView ? '12px' : '18px'}
      >
        <Heading as="h1" dataHook={dataHook || ''}>
          <Text>{t(titleKey)}</Text>
        </Heading>
        <Text className={s.subtitle}>{t(subtitleKey)}</Text>
      </Box>
    </Box>
  );
};

export default HeaderBanner;
